import { render, staticRenderFns } from "./projectStatusesList.vue?vue&type=template&id=6f900df6&scoped=true&"
import script from "./projectStatusesList.vue?vue&type=script&lang=js&"
export * from "./projectStatusesList.vue?vue&type=script&lang=js&"
import style0 from "./projectStatusesList.vue?vue&type=style&index=0&id=6f900df6&lang=scss&scoped=true&"
import style1 from "./projectStatusesList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f900df6",
  null
  
)

export default component.exports